(function($, undefined) {
	'use strict';

	var init = function() {
		$('.save-com-certification-header-settings-btn').on('click', onSaveSettingsClick);
	};

	function onSaveSettingsClick() {
		var btn = $(this);
		var ctn = btn.closest('.stool-shared-popup-content-ctn-inner');
		var select = $('[name=com-certification-header-admin-category-select]', ctn);
		var json = {
			"typeEvents": "category",
			"valueEvents": select.val()
		};
		var label = btn.attr("data-site-label");

		btn.addClass("has-processing_active");
		updateLabel(label, JSON.stringify(json), $("html").attr("lang"), () => {
			btn.removeClass("has-processing_active");
			$('.form-message_success', ctn).slideDown(300);

			setTimeout(() => {
				$('.form-message_success', ctn).slideUp(300);
			}, 4000);
		}, true);
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
